import React from 'react';

import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import { useGradeProfileStore } from 'store/grade/useGradeProfileStore';

const Program = ({ progress }) => {
	// Use grade's profile store
	const program = useGradeProfileStore(state => state.program);

	if (!program.id && !progress) {
		return (
			<div className="py-3 px-4 flex bg-red-500 text-white rounded-lg">
				Klase nav piesaistīta programmai!
			</div>
		);
	}

	return (
		<Container className="p-4 flex items-start">
			<div className="flex-1 flex items-center overflow-hidden">
				<Title
					title={program.title}
					className="flex-1 whitespace-nowrap text-ellipsis overflow-hidden"
				/>

				<div className="ml-3 flex">
					<Button
						small
						square
						icon="link"
						to={`/programs/${program.id}`}
					/>
				</div>
			</div>
		</Container>
	);
};

export default Program;